<template>
    <div class="vh-100 main-frame" :style="bgImg">
        <div class="shade-layer text-center pt-5">
            <p class="icon-size mt-2 mb-0"><i class="bi bi-x-circle-fill"></i></p>
            <p class="fw-bold fs-2">{{ $t('paymentFailed.title') }}</p>
            <p class="mx-4">{{ $t('paymentFailed.message') }}
                <router-link to="/contact">{{ $t('paymentFailed.customerService') }}</router-link>
            </p>
            <button class="btn btn-dark" @click="returnToTransaction">{{ $t('paymentFailed.backToTransactions') }}</button>
        </div>
    </div>
</template>

<script>
    export default {
        name: "PaymentFailed",
        data() {
            return {
                bgImg: {
                    backgroundImage: `url(${require('../../public/img/undraw_cancel_re_pkdm.svg')})`,
                    position: 'relative',
                    backgroundPosition: 'bottom',
                    backgroundSize: '75% 75%',
                    backgroundRepeat: 'no-repeat'
                }
            }
        },
        methods: {
            returnToTransaction(){
                this.$router.replace('/transactions')
            }
        }
    }
</script>

<style scoped>
.icon-size {
  font-size: 50pt;
}

.shade-layer {
  background: linear-gradient(135deg, rgba(220, 53, 69, 0.7), rgba(210, 210, 207, 0.7));
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
</style>
